import { colors } from "@quickpoint.me/shared";
import styled from "styled-components";

/**
 * Full-screen auth layout in the app's own language: white canvas, Avantt,
 * lavender hairlines, one purple. All inks are AAA on white (see
 * STYLE_GUIDE.md — chrome ink #333 11.9:1, content ink #111 18.9:1).
 */
export const StyledInput = styled.div<{ $isInPortrait: boolean }>`
    align-items: center;
    background: #ffffff;
    color: #111111;
    /* NOT an inner scroll container: Safari anchors the password-manager
     * autofill popup to the top-left of a positioned overflow:auto ancestor,
     * not to the (vertically-centered) input. Grow with content and let the
     * page scroll instead, so the popup lands on the field. */
    display: grid;
    min-height: 100svh;
    justify-items: center;
    position: absolute;
    width: 100%;
    z-index: 60;
    font-family: "Avantt-Regular", sans-serif;
    font-size: 1rem;
    align-content: center;
    row-gap: 1rem;

    grid-template-areas:
        "banner"
        "info"
        "form"
        "more-info"
        "buttons";

    .pick-account-name {
      color: #333333;
      margin: 0;
    }

    .pick-account-name-live {
      /* white on #5335C9: 7.7:1 (AAA) */
      color: #ffffff;
      background: #5335c9;
      border-radius: 4px;
      padding: 0.1em 0.35em;
    }

    .banner {
      grid-area: banner;
      align-self: end;
      display: flex;
      justify-content: center;
      padding-block-start: 1rem;

      svg {
        /* horizontal lockup (837×131) */
        width: min(19rem, 80svw);
        height: auto;
      }
    }

    .info {
        grid-area: info;
        text-align: center;
        color: #333333;
    }

    .form {
        grid-area: form;
        width: ${(props) => (props.$isInPortrait ? "92svw" : "min(26rem, 90svw)")};
    }

    .more-info {
        grid-area: more-info;
        text-align: center;
        color: #333333;
        hr {
          background-color: ${(props) => props.theme.navigationFrame ?? "#E5E1F8"};
          height: 1px;
          border: none;
        }
    }

    .buttons {
        grid-area: buttons;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.8rem;
        width: min(20rem, 90svw);
        padding-block-end: 2rem;
    }
    .signup-choices-list {
        text-align: left;
    }
`;

/** App-style text inputs: 3:1 border, AAA placeholder, visible focus. */
export const authInputCss = `
  .auth-input {
    background: #ffffff;
    color: #111111;
    border: 1px solid #757575; /* 4.6:1 on white — clears the 3:1 UI minimum */
    border-radius: 6px;
    padding: 0.6em 0.75em;
    min-height: 48px;
    width: 100%;
    font-family: inherit;
    font-size: 1rem;

    &::placeholder {
      color: ${colors.textSafe.grey}; /* 7:1 (AAA) */
      opacity: 1;
    }

    &:focus-visible {
      outline: 3px solid #4a90d9;
      outline-offset: 2px;
    }

    &[aria-invalid="true"] {
      border-color: ${colors.textSafe.red};
      border-width: 2px;
    }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-text-fill-color: #111111 !important;
    -webkit-box-shadow: 0 0 0 100px #f7f5ff inset !important;
  }
`;
